import apiFetch from '@scale/frontend-lib/api-fetch';
import {
  DisableTaskersOneProjectRequest,
  PurgeTaskersWorkOneProjectRequest,
  MassAddPermissionsRequest,
} from '@scale/shared-types';
import { ChannelType } from '@scale/shared/workerSlack/constants';

export async function disableTaskersOneProject(body: DisableTaskersOneProjectRequest) {
  return await apiFetch(null, `corp-api/disable_taskers_one_project/sync`, {
    method: 'POST',
    body,
  });
}

export async function purgeTaskersWorkOneProjectPreview(body: PurgeTaskersWorkOneProjectRequest) {
  return await apiFetch(null, `corp-api/purge_taskers_work_one_project/preview`, {
    method: 'POST',
    body,
  });
}

export async function purgeTaskersWorkOneProject(body: PurgeTaskersWorkOneProjectRequest) {
  return await apiFetch(null, `corp-api/purge_taskers_work_one_project`, {
    method: 'POST',
    body,
  });
}

export async function massAddPermissions(body: MassAddPermissionsRequest) {
  return await apiFetch(null, `corp-api/mass_add_permissions/sync`, {
    method: 'POST',
    body,
  });
}

export async function getSlackInviteLink(type?: ChannelType): Promise<{ link: string }> {
  return await apiFetch(null, `internal/slack/inviteLink/${type ?? 'default'}`, {
    method: 'GET',
  });
}
